module.exports = __webpack_public_path__ + "static/media/sphere.81aa7f24.png";